angular.module('unica_workshop.workshop_controllers', [])

.controller('WorkshopBasicController',
	function(
		$rootScope, $scope, $stateParams,
		FileUploader, getBaseApiURL, Session,
		WorkshopDeleteService
	) {

	$scope.forms = {};

	$scope.uploader =  new FileUploader({
		removeAfterUpload: true,
		url: getBaseApiURL + '/workshop/update-workshop-material',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploader.onAfterAddingAll = function(addedFileItems) {
		angular.forEach(addedFileItems, function(el) {
			if ( el.alias == 'material_pre_event' ) {
				$rootScope.workshopData.filename_pre_event = el.file.name;
			} else if ( el.alias == 'material_post_event' ) {
				$rootScope.workshopData.filename_post_event = el.file.name;
			}
		});
	};

	$scope.uploader.onCompleteAll = function() {
		$scope.hideLoader();
		$scope.showSuccessMsg('Workshop aggiunto con successo!', '');
	};



	$rootScope.workshopData = {
		event_id: $stateParams.event_id,
		filename_pre_event: '',
		filename_post_event: '',
	};



	$scope.deleteWorkshopMaterial = function( workshopId, type ) {
		$scope.showLoader();
		WorkshopDeleteService
			.deleteWorkshopMaterial( workshopId, type )
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$rootScope.workshopData = data;
					angular.element(document.querySelector('.workshop_material_' + type + '_event')).val(null);
					$scope.showSuccessMsg('Materiale Workshop rimosso con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.clearWorkshopMaterial = function(type) {
		angular.element(document.querySelector('.workshop_material_' + type + '_event')).val(null);
		$scope.uploader.clearQueue();
		if ( type == 'pre' ) {
			$rootScope.workshopData.filename_pre_event = null;
		} else if ( type == 'post' ) {
			$rootScope.workshopData.filename_post_event = null;
		}
	};

});


